import React from "react"

import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

import consult from "../../images/commusa-icon-consult.svg"
import price from "../../images/commusa-icon-price.svg"
import quality from "../../images/commusa-icon-quality.svg"

function LocationsIntro() {

  const images = useStaticQuery(graphql`
      query{
          twoWayRadios5: file(relativePath: {eq: "commusa-two-way-radios-5.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          twoWayRadios2: file(relativePath: {eq: "commusa-two-way-radio-solutions-2.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
      }
  `)

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-6 pb-5 pt-3 pt-lg-5">
            <h1 className="display-3">CommUSA Locations</h1>
            <h6 className="mb-3">Buy and Rent Two-Way Radios from North America’s most knowledgeable Motorola Dealer
              with price match guarantee</h6>
            <div className="btn-group" role="group">
              <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                          href="https://www.commusa.com/contact-us">Request
              Quote</a>
            </div>
          </div>
          <div className="col-12 col-lg-6 d-flex flex-column order-first order-lg-last px-0 px-lg-3 py-0"><Img
            className="w-100" fluid={images.twoWayRadios5.childImageSharp.fluid}
            alt="CommUSA - Best Priced Two Way Radios &amp; Accessories"/></div>
        </div>
        <div className="row py-5 iconbox py-md-3 py-lg-5">
          <div className="col-12">
            <h3 className="text-center mb-3">Same-day fulfillment on most orders with thousands of units on hand</h3>
            <div className="row">
              <div className="col-12 col-sm-4 d-flex justify-content-center mb-3">
                <div className="d-flex flex-column align-items-center flex-md-row text-center text-md-left">
                  <img className="comm-icon mb-2 mr-md-2 mb-md-0" src={consult} alt="Knowledgeable Consultants"/>
                  <h6 className="mb-0">Knowledgeable Consultants</h6>
                </div>
              </div>
              <div className="col-12 col-sm-4 d-flex justify-content-center mb-3">
                <div className="d-flex flex-column align-items-center flex-md-row text-center text-md-left">
                  <img className="comm-icon mb-2 mr-md-2 mb-md-0" src={quality} alt="Highest Quality Products"/>
                  <h6 className="mb-0">Highest Quality Products</h6>
                </div>
              </div>
              <div className="col-12 col-sm-4 d-flex justify-content-center mb-3">
                <div className="d-flex flex-column align-items-center flex-md-row text-center text-md-left">
                  <img className="comm-icon mb-2 mr-md-2 mb-md-0" src={price} alt="Best Pricing" />
                  <h6 className="mb-0">Best Pricing</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container pt-3 pt-lg-0 pb-5">
        <div className="row">
          <div className="col mb-lg-3"><Img className="w-100 mb-3"
                                            fluid={images.twoWayRadios2.childImageSharp.fluid}
                                            alt="CommUSA - Two-Way Radio Solutions"/></div>
          <div className="col-12 col-lg-6 d-flex flex-column justify-content-center mb-3 order-first order-lg-last">
            <h4>Our consultants help you pick the right product and solution for your needs</h4>
            <p>When it comes to running your business successfully, you know communication is critical. That’s why
              you’re always on the lookout for the most efficient two-way radios on the market.</p>
            <p>Your search is finally over because CommUSA is a one-stop-shop for the highest quality two-way radios and
              accessories.</p>
            <p>We offer an extensive selection of value-priced radios, from convenient portable two-way radios to
              powerful mobile radios and base stations. Plus, our impressive stock of two-way radio accessories means
              you don’t have to look elsewhere for batteries, headsets, surveillance kits, and more.</p>
            <div className="btn-group" role="group">
              <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
                className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                          href="https://www.commusa.com/contact-us">Request
              Quote</a>
            </div>
          </div>
        </div>
        <div className="row">

        </div>
      </div>
    </>
  )
}

export default LocationsIntro
